import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../experience/api";
import "./gold.css";

const FONTS = '@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&family=Yeseva+One&display=swap");';
const FINE = "No purchase necessary. 18+. See rules at myurbanpassport.com/gold. Void where prohibited.";

const deviceId = () => {
  let d = localStorage.getItem("gold_device");
  if (!d) { d = `gd-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem("gold_device", d); }
  return d;
};

const Shell = ({ children }) => (
  <div className="gd-root">
    <style>{FONTS}</style>
    <div className="gd-wrap">
      <img src="/gold/logo.png" alt="Urban Turban" className="gd-logo" />
      <div className="gd-brand">
        <h2>Urban Turban</h2>
        <p>Chicago's Modern Indian Dhaba</p>
        <p style={{ letterSpacing: "0.14em", color: "#8a6a52" }}>Indian · Punjabi · Pakistani</p>
      </div>
      {children}
    </div>
  </div>
);

const Coin = () => <img src="/gold/coin.png" alt="1 gram gold coin" className="gd-coin-img" />;

/* ---------- /gold landing ---------- */
export function GoldLanding() {
  return (
    <Shell>
      <div style={{ marginTop: 22, display: "flex", alignItems: "flex-end", justifyContent: "center", gap: 18 }}>
        <img src="/assets/babaji-elder.png" alt="Urban Turban Babaji" data-testid="gold-hero-babaji"
          style={{ width: 92, filter: "drop-shadow(0 0 14px rgba(212,175,55,.55))" }} />
        <Coin />
      </div>
      <h1 className="gd-h1" data-testid="gold-landing-title">Dine In, Win Gold</h1>
      <p className="gd-sub">Monthly draw of a 1 gram gold coin, from our Indian and Punjabi kitchen in Lincoln Park. A new winner every month.</p>
      <div className="gd-card">
        <span className="gd-label">How to enter</span>
        <p className="gd-rule-p">Dine in at Urban Turban Lincoln Park and scan the QR code on your paid receipt. Every guest at your table can enter.</p>
        <span className="gd-label">The draw</span>
        <p className="gd-rule-p">Each month is its own entry period. One winner is picked on the first business day of the next month and notified by phone and email.</p>
        <p className="gd-rule-p">Also: order online at tryurbanturban.com and you are in the monthly draw for a 1 oz silver coin.</p>
        <p className="gd-rule-p" style={{ fontWeight: 800 }}>One winner every month. Good luck!</p>
      </div>
      <Link to="/gold/rules" data-testid="gold-rules-link"><button className="gd-btn alt">Read the Official Rules</button></Link>
      <Link to="/gold/my-entries" data-testid="gold-myentries-link"><button className="gd-btn alt" style={{ marginTop: 10 }}>Check my entries</button></Link>
      <p className="gd-fine">{FINE}</p>
    </Shell>
  );
}

/* ---------- /gold/e/{code} entry ---------- */
export function GoldEntry() {
  const { code } = useParams();
  const [info, setInfo] = useState(null);
  const [phase, setPhase] = useState("loading"); // loading | invalid | form | entered | done
  const [invalidMsg, setInvalidMsg] = useState("");
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [offers, setOffers] = useState(false);
  const [agree, setAgree] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [spots, setSpots] = useState(null);
  const [myCount, setMyCount] = useState(null);
  const lastEmail = sessionStorage.getItem("gold_last_email") || "";

  const mapInvalid = (reason, detail) => {
    const r = `${reason || ""} ${detail || ""}`.toLowerCase();
    if (r.includes("used") || r.includes("full") || r.includes("everyone")) return "Everyone at this table is already entered. Thanks for dining with us!";
    if (r.includes("expire")) return "This code expired 24 hours after your visit. Come back soon for a new one!";
    return "We could not find that code. Please check the link on your receipt.";
  };

  const load = () => {
    api.get(`/gold/code/${encodeURIComponent(code)}`).then((r) => {
      setInfo(r.data);
      setSpots(r.data.spots_left);
      if (r.data.valid) setPhase("form");
      else { setInvalidMsg(mapInvalid(r.data.reason)); setPhase("invalid"); }
    }).catch((e) => { setInvalidMsg(mapInvalid("", e.response?.data?.detail)); setPhase("invalid"); });
  };
  useEffect(load, [code]); // eslint-disable-line react-hooks/exhaustive-deps

  const goDone = (em) => {
    setPhase("done");
    const target = em || lastEmail;
    if (target) api.get("/gold/my-entries", { params: { email: target } }).then((r) => setMyCount(r.data.count)).catch(() => {});
  };

  const submit = async () => {
    setErr("");
    if (!first.trim()) return setErr("Please add your first name");
    if (!/.+@.+\..+/.test(email.trim())) return setErr("Please add a valid email");
    if (!agree) return setErr("Please agree to the Official Rules to enter");
    setBusy(true);
    try {
      const r = await api.post("/gold/entry", {
        code, first_name: first.trim(), email: email.trim(), phone: phone.trim(),
        offers_optin: offers, rules_agreed: true, device_id: deviceId() });
      sessionStorage.setItem("gold_last_email", email.trim().toLowerCase());
      const left = r.data.spots_left ?? (spots != null ? Math.max(0, spots - 1) : null);
      setSpots(left);
      if (left === 0) goDone(email.trim().toLowerCase()); else setPhase("entered");
    } catch (e) {
      const d = (e.response?.data?.detail || "").toLowerCase();
      if (d.includes("email") && d.includes("already")) setErr("This email is already in for this bill. Pass the phone to the next guest!");
      else if (d.includes("expire")) setErr("This code expired 24 hours after your visit. Come back soon for a new one!");
      else if (d.includes("full") || d.includes("everyone") || d.includes("used")) setErr("Everyone at this table is already entered. Thanks for dining with us!");
      else setErr(e.response?.data?.detail || "Something went wrong. Please try again.");
    }
    setBusy(false);
  };

  const passPhone = () => { setFirst(""); setEmail(""); setPhone(""); setOffers(false); setAgree(false); setErr(""); setPhase("form"); load(); };

  return (
    <Shell>
      {phase === "loading" && <p className="gd-sub" style={{ marginTop: 30 }}>Checking your code…</p>}

      {phase === "invalid" && (
        <div className="gd-card" style={{ textAlign: "center" }} data-testid="gold-invalid">
          <img src="/assets/babaji-elder.png" alt="Elder VeerGi" style={{ width: 110, filter: "drop-shadow(0 0 12px rgba(212,175,55,.5))" }} />
          <p style={{ fontSize: 15, fontWeight: 700, margin: "10px 0 0" }} data-testid="gold-invalid-msg">{invalidMsg}</p>
          <Link to="/gold" className="gd-link" style={{ display: "inline-block", marginTop: 12 }}>About the giveaway</Link>
        </div>
      )}

      {phase === "form" && (
        <>
          <div className="gd-babaji">
            <img src="/assets/babaji-elder.png" alt="Elder VeerGi welcomes you" data-testid="gold-babaji" />
            <div className="gd-bubble">Fill this in and you could win gold.</div>
          </div>
          <div className="gd-card" data-testid="gold-form">
            <div>
              <span className="gd-lock" data-testid="gold-location">{info?.location || "Lincoln Park"}</span>
              {info?.bill_no_masked && <span className="gd-lock" data-testid="gold-bill">Bill {info.bill_no_masked}</span>}
              {spots != null && <span className="gd-lock">{spots} spot{spots === 1 ? "" : "s"} left</span>}
            </div>
            <span className="gd-label">First name *</span>
            <input className="gd-input" data-testid="gold-first-input" value={first} onChange={(e) => setFirst(e.target.value)} placeholder="Your first name" />
            <span className="gd-label">Email *</span>
            <input className="gd-input" data-testid="gold-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            <button className="gd-btn" data-testid="gold-enter-btn" disabled={busy} onClick={submit}>{busy ? "ENTERING…" : "ENTER TO WIN"}</button>
            <span className="gd-label" style={{ marginTop: 18 }}>Phone (optional)</span>
            <input className="gd-input" data-testid="gold-phone-input" inputMode="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="For a reminder before the draw" />
            <label className="gd-check" data-testid="gold-offers-check">
              <input type="checkbox" checked={offers} onChange={(e) => setOffers(e.target.checked)} />
              <span><b>Email me Urban Turban offers</b><br /><span style={{ fontSize: 11.5, color: "#8a6a52" }}>Occasional treats and news. Totally optional, never affects your chances.</span></span>
            </label>
            <label className="gd-check" data-testid="gold-rules-check">
              <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
              <span>I agree to the <Link className="gd-link" to="/gold/rules">Official Rules</Link> *</span>
            </label>
            {err && <div className="gd-err" data-testid="gold-form-error">{err}</div>}
          </div>
          <p className="gd-fine">No purchase needed. See rules for free mail-in entry.<br />{FINE}</p>
        </>
      )}

      {phase === "entered" && (
        <div className="gd-card" style={{ textAlign: "center" }} data-testid="gold-entered">
          <Coin />
          <h1 className="gd-h1" style={{ fontSize: 24 }} data-testid="gold-entered-msg">
            You're in!{spots != null ? ` ${spots} more spot${spots === 1 ? "" : "s"} for your table` : ""}
          </h1>
          <button className="gd-btn" data-testid="gold-pass-phone-btn" onClick={passPhone}>PASS THE PHONE</button>
          <button className="gd-btn alt" style={{ marginTop: 10 }} data-testid="gold-done-btn" onClick={() => goDone()}>Done</button>
        </div>
      )}

      {phase === "done" && (
        <div className="gd-card" style={{ textAlign: "center" }} data-testid="gold-done">
          <img src="/assets/babaji-elder.png" alt="Elder VeerGi" style={{ width: 130, filter: "drop-shadow(0 0 14px rgba(212,175,55,.55))" }} />
          <h1 className="gd-h1" style={{ fontSize: 24 }}>You are in this month's gold draw</h1>
          {myCount != null && <p style={{ fontSize: 15, fontWeight: 800, color: "#B8892B", margin: "6px 0 0" }} data-testid="gold-entry-count">You have {myCount} {myCount === 1 ? "entry" : "entries"}</p>}
          <p className="gd-sub" style={{ marginTop: 8 }}>Watch your phone and email after the draw. One winner every month. Good luck!</p>
          <Link to="/gold/my-entries" className="gd-link" style={{ display: "inline-block", marginTop: 12 }}>See my entries</Link>
        </div>
      )}
    </Shell>
  );
}

/* ---------- /gold/my-entries ---------- */
export function GoldMyEntries() {
  const [email, setEmail] = useState(sessionStorage.getItem("gold_last_email") || "");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    if (!/.+@.+\..+/.test(email.trim())) return;
    setBusy(true);
    try { const r = await api.get("/gold/my-entries", { params: { email: email.trim() } }); setRes(r.data); }
    catch { setRes({ count: 0, entries: [] }); }
    setBusy(false);
  };
  useEffect(() => { if (email) check(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Shell>
      <h1 className="gd-h1">My coin entries</h1>
      <p className="gd-sub">Enter the email you used and we will count you in</p>
      <div className="gd-card">
        <span className="gd-label">Email</span>
        <input className="gd-input" data-testid="gold-my-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" onKeyDown={(e) => e.key === "Enter" && check()} />
        <button className="gd-btn" data-testid="gold-my-check-btn" disabled={busy} onClick={check}>{busy ? "CHECKING…" : "CHECK MY ENTRIES"}</button>
        {res && (
          <div style={{ marginTop: 16 }} data-testid="gold-my-results">
            <p style={{ fontSize: 16, fontWeight: 800, color: "#B8892B", margin: 0 }} data-testid="gold-my-month">
              This month{res.current_month?.gold?.month_label ? ` (${res.current_month.gold.month_label})` : ""}: Gold {res.current?.gold ?? 0}, Silver {res.current?.silver ?? 0}
            </p>
            {(res.past_months || []).map((m, i) => (
              <div key={i} className="gd-entry-row" data-testid={`gold-past-${i}`}>
                <span style={{ fontWeight: 700 }}>{m.month_label || m.month}</span>
                <span style={{ color: "#8a6a52" }}>Gold {m.gold ?? 0}, Silver {m.silver ?? 0} · Closed</span>
              </div>
            ))}
            {(res.entries || []).map((en, i) => (
              <div key={`e${i}`} className="gd-entry-row">
                <span style={{ fontWeight: 700, textTransform: "capitalize" }}>{en.prize_type || "gold"} · {(en.source || en.type || "entry").replace(/_/g, " ")}</span>
                <span style={{ color: "#8a6a52" }}>{(en.created_at || en.date || "").slice(0, 10)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Link to="/gold"><button className="gd-btn alt">About the giveaway</button></Link>
      <p className="gd-fine">{FINE}</p>
    </Shell>
  );
}

/* ---------- /gold/rules ---------- */
const R = ({ n, t, children }) => (<><p className="gd-rule-h">{n}. {t}</p><div className="gd-rule-p">{children}</div></>);
export function GoldRules() {
  return (
    <Shell>
      <h1 className="gd-h1" style={{ fontSize: 24 }}>Official Rules: Urban Turban Monthly Gold and Silver Giveaways</h1>
      <div className="gd-card" data-testid="gold-rules">
        <p className="gd-rule-p" style={{ fontWeight: 800 }}>NO PURCHASE NECESSARY TO ENTER OR WIN. A purchase does not increase your chances of winning.</p>
        <p className="gd-rule-p">Urban Turban runs two separate monthly draws:</p>
        <p className="gd-rule-p"><b>DINE IN, WIN GOLD:</b> monthly draw of a 1 gram gold coin.</p>
        <p className="gd-rule-p"><b>ORDER ONLINE, WIN SILVER:</b> monthly draw of a 1 oz silver coin.</p>
        <R n={1} t="Sponsor">Urban Turban LLC, 2660 N Halsted St, Chicago, IL 60614 ("Urban Turban" or "Sponsor").</R>
        <R n={2} t="Who can enter">Legal residents of Illinois and the United States who are 18 or older at the time of entry. Employees of Urban Turban and their immediate families and household members cannot enter. Void where prohibited.</R>
        <R n={3} t="Entry periods">
          <p className="gd-rule-p">Each calendar month is its own entry period for each draw. It starts at 12:00 AM Central Time on the 1st and ends at 11:59 PM Central Time on the last day of the month.</p>
          <p className="gd-rule-p">Dine-in entries made October 27 to October 31, 2026 roll into the November 2026 gold draw. The silver draw starts with November 2026.</p>
          <p className="gd-rule-p">Entries do not carry over. Each month's entries count only for that month's draw.</p>
          <p className="gd-rule-p">The giveaways run month to month until Sponsor ends them by posting an end date on the rules page with at least 30 days notice.</p>
        </R>
        <R n={4} t="How to enter the GOLD draw (Dine In, Win Gold)">
          <p className="gd-rule-p"><b>Dine in</b> at Urban Turban, 2660 N Halsted St, Chicago. Scan the QR code on your paid dine-in receipt and complete the short form. Each guest at the table may enter once with their own email (up to 12 per bill). Codes expire 24 hours after payment. An entry counts in the month the bill was paid.</p>
          <p className="gd-rule-p">Online, delivery app, and pickup orders are not gold entries.</p>
        </R>
        <R n={5} t="How to enter the SILVER draw (Order Online, Win Silver)">
          <p className="gd-rule-p"><b>Order online</b> at tryurbanturban.com. Each paid online order is entered automatically into that month's silver draw (one entry per paid order). Cancelled or fully refunded orders are removed. Orders through third-party delivery apps (DoorDash, Uber Eats, Grubhub and others) are not entries.</p>
        </R>
        <R n={6} t="Free entry, no purchase (both draws)">
          <p className="gd-rule-p">You can enter either draw for free, with the same chance of winning as a paid entry. Choose one:</p>
          <p className="gd-rule-p"><b>Online form:</b> go to <Link className="gd-link" to="/gold/free-entry">myurbanpassport.com/gold/free-entry</Link>, pick Gold or Silver, and enter your first name, last name, email, and phone.</p>
          <p className="gd-rule-p"><b>Mail-in:</b> mail a postcard with your full name, email, phone, and the word "GOLD" or "SILVER" to: Monthly Giveaway, Urban Turban, 2660 N Halsted St, Chicago, IL 60614. A postcard counts in the month it is postmarked and must arrive within 7 days after that month ends.</p>
          <p className="gd-rule-p">Limit: one free entry per person, per draw, per month (by any free method combined).</p>
        </R>
        <R n={7} t="Prizes and approximate retail value">
          <p className="gd-rule-p"><b>Gold:</b> one (1) 1 gram gold coin per month. Approximate retail value (ARV): <b>$175</b>.</p>
          <p className="gd-rule-p"><b>Silver:</b> one (1) 1 oz silver coin per month. Approximate retail value (ARV): <b>$60</b>.</p>
          <p className="gd-rule-p">ARV based on precious metal spot prices on October 29, 2026 (gold about $4,020 per troy oz, silver about $52 per troy oz) plus a typical dealer premium for a small coin. Metal prices change; the actual value on the draw date may be higher or lower. No cash or substitution, except Sponsor may substitute a coin of equal or greater value. Taxes are the winner's responsibility.</p>
          <p className="gd-rule-p">One prize per person in any 12-month period, across both draws.</p>
        </R>
        <R n={8} t="Odds">Odds of winning each draw depend on the number of eligible entries received for that draw in that month.</R>
        <R n={9} t="How winners are picked">One gold winner and one silver winner are picked at random from that month's eligible entries for each draw, on the first business day (Monday to Friday, not a federal holiday) of the next month. Sponsor runs the draws with a random selection tool and keeps a log.</R>
        <R n={10} t="Winner notice and claim">Winners are notified by phone and email using the details given at entry. A winner has 7 days from notice to respond, show photo ID matching the entry, and pick up the coin at 2660 N Halsted St during open hours (2 PM to 11 PM, closed Tuesday). If a winner does not respond or is not eligible, an alternate winner for that month may be drawn.</R>
        <R n={11} t="Email offers">Marketing emails go only to entrants who check "Email me Urban Turban offers." Checking it does not affect your chances. Unsubscribe anytime.</R>
        <R n={12} t="General">By entering, you agree to these rules. Sponsor may void entries made by automated means, fake details, or other abuse, and may cancel or change the giveaways if fraud or technical problems affect them, with notice on the rules page. Not sponsored by or affiliated with any delivery app or social platform. A winner's first name and last initial may be shared, with consent.</R>
        <R n={13} t="Winners list and questions">For a month's winner names, email tryurbanturban@gmail.com within 60 days after that draw. Questions: ask at the restaurant or email tryurbanturban@gmail.com.</R>
      </div>
      <Link to="/gold"><button className="gd-btn alt">Back to the giveaway</button></Link>
    </Shell>
  );
}

/* ---------- /gold/free-entry ---------- */
export function GoldFreeEntry() {
  const [prize, setPrize] = useState("gold");
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [adult, setAdult] = useState(false);
  const [offers, setOffers] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async () => {
    setErr("");
    if (!first.trim()) return setErr("Please add your first name");
    if (!last.trim()) return setErr("Please add your last name");
    if (!/.+@.+\..+/.test(email.trim())) return setErr("Please add a valid email");
    if (!phone.trim()) return setErr("Please add your phone number");
    if (!adult) return setErr("You must be 18 or older to enter");
    setBusy(true);
    try {
      const r = await api.post("/gold/free-entry", {
        prize, first_name: first.trim(), last_name: last.trim(), email: email.trim(),
        phone: phone.trim(), adult: true, offers_optin: offers, device_id: deviceId() });
      setDone(r.data);
    } catch (e) {
      setErr(e.response?.data?.detail || "Something went wrong. Please try again.");
    }
    setBusy(false);
  };

  const chip = (val, label, sub) => (
    <button key={val} data-testid={`gold-free-prize-${val}`} onClick={() => setPrize(val)}
      style={{ flex: 1, cursor: "pointer", borderRadius: 14, padding: "12px 8px", fontFamily: "Poppins, sans-serif",
        border: prize === val ? "2px solid #B8892B" : "1.5px solid #e4d5b8",
        background: prize === val ? "#fdf3dd" : "#fffdf7", color: "#4a3a28" }}>
      <b style={{ display: "block", fontSize: 14 }}>{label}</b>
      <span style={{ fontSize: 11.5, color: "#8a6a52" }}>{sub}</span>
    </button>
  );

  return (
    <Shell>
      <h1 className="gd-h1" style={{ fontSize: 26 }}>Free entry, no purchase</h1>
      <p className="gd-sub">Pick a draw and enter free. Same chance of winning as any entry. One free entry per person, per draw, per month.</p>
      {done ? (
        <div className="gd-card" style={{ textAlign: "center" }} data-testid="gold-free-done">
          <img src="/assets/babaji-elder.png" alt="Elder VeerGi" style={{ width: 120, filter: "drop-shadow(0 0 14px rgba(212,175,55,.55))" }} />
          <h1 className="gd-h1" style={{ fontSize: 22 }} data-testid="gold-free-done-msg">
            You are in the {done.month_label || "monthly"} {done.prize_type || prize} draw
          </h1>
          <p className="gd-sub" style={{ marginTop: 8 }}>Watch your phone and email after the draw. One winner every month. Good luck!</p>
          <Link to="/gold/my-entries" className="gd-link" style={{ display: "inline-block", marginTop: 12 }}>See my entries</Link>
        </div>
      ) : (
        <div className="gd-card" data-testid="gold-free-form">
          <span className="gd-label">Which draw? *</span>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            {chip("gold", "Gold", "1 gram gold coin · dine-in draw")}
            {chip("silver", "Silver", "1 oz silver coin · online draw")}
          </div>
          <span className="gd-label">First name *</span>
          <input className="gd-input" data-testid="gold-free-first" value={first} onChange={(e) => setFirst(e.target.value)} placeholder="First name" />
          <span className="gd-label">Last name *</span>
          <input className="gd-input" data-testid="gold-free-last" value={last} onChange={(e) => setLast(e.target.value)} placeholder="Last name" />
          <span className="gd-label">Email *</span>
          <input className="gd-input" data-testid="gold-free-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
          <span className="gd-label">Phone *</span>
          <input className="gd-input" data-testid="gold-free-phone" inputMode="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Your phone number" />
          <label className="gd-check" data-testid="gold-free-adult">
            <input type="checkbox" checked={adult} onChange={(e) => setAdult(e.target.checked)} />
            <span>I am 18 or older *</span>
          </label>
          <label className="gd-check" data-testid="gold-free-offers">
            <input type="checkbox" checked={offers} onChange={(e) => setOffers(e.target.checked)} />
            <span><b>Email me Urban Turban offers</b><br /><span style={{ fontSize: 11.5, color: "#8a6a52" }}>Optional, never affects your chances.</span></span>
          </label>
          <button className="gd-btn" data-testid="gold-free-submit" disabled={busy} onClick={submit}>{busy ? "ENTERING…" : "ENTER FREE"}</button>
          {err && <div className="gd-err" data-testid="gold-free-error">{err}</div>}
        </div>
      )}
      <Link to="/gold/rules" className="gd-link" style={{ display: "inline-block", marginTop: 14 }}>Read the Official Rules</Link>
      <p className="gd-fine">{FINE}</p>
    </Shell>
  );
}
